export const SLICING_DESCRIPTIONS = [
    "Pokroję Twój chleb równiutko i wygodnie!",
    "Świeżo krojony chleb - prosty sposób na idealne kanapki!",
    "Idealnie pokrojony chleb prosto do Twojego domu!",
    "Równe kromki na życzenie!",
    "Wygodnie pokrojony chleb - gotowy do użycia!",
    "Nie masz ostrego noża? Nie ma problemu!",
    "Równiutko pokrojony chleb od ręki!"
];
